import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const VISITED_PAGES_KEY = 'orderlab_visited_pages';
const VISIT_EVENT = 'pageVisitUpdate';

export const usePageVisit = () => {
  const getVisitedPages = () => {
    const stored = localStorage.getItem(VISITED_PAGES_KEY);
    return stored ? JSON.parse(stored) : [];
  };

  const markPageAsVisited = (pagePath) => {
    const visited = getVisitedPages();
    if (!visited.includes(pagePath)) {
      visited.push(pagePath);
      localStorage.setItem(VISITED_PAGES_KEY, JSON.stringify(visited));
      // Déclencher un événement pour notifier les composants
      window.dispatchEvent(new CustomEvent(VISIT_EVENT));
    }
  };

  const hasVisitedPage = (pagePath) => {
    const visited = getVisitedPages();
    return visited.includes(pagePath);
  };

  const resetVisitedPages = () => {
    localStorage.removeItem(VISITED_PAGES_KEY);
    window.dispatchEvent(new CustomEvent(VISIT_EVENT));
  };

  return {
    getVisitedPages,
    markPageAsVisited,
    hasVisitedPage,
    resetVisitedPages,
  };
};

// Hook pour marquer automatiquement la page actuelle comme visitée
export const useMarkPageVisited = (customPath = null) => {
  const location = useLocation();
  
  useEffect(() => {
    // Utiliser le chemin personnalisé ou le pathname actuel
    const pagePath = customPath || location.pathname;
    
    if (pagePath) {
      const stored = localStorage.getItem(VISITED_PAGES_KEY);
      const visited = stored ? JSON.parse(stored) : [];
      
      if (!visited.includes(pagePath)) {
        visited.push(pagePath);
        localStorage.setItem(VISITED_PAGES_KEY, JSON.stringify(visited));
        window.dispatchEvent(new CustomEvent(VISIT_EVENT));
        console.log('✅ Page marked as visited:', pagePath); // Debug
      }
    }
  }, [customPath, location.pathname]);
};

// Hook pour écouter les changements de visite et forcer le re-render
export const useVisitListener = () => {
  const [, setUpdate] = useState(0);
  
  useEffect(() => {
    const handleVisitUpdate = () => {
      setUpdate(prev => prev + 1);
    };
    
    window.addEventListener(VISIT_EVENT, handleVisitUpdate);
    return () => window.removeEventListener(VISIT_EVENT, handleVisitUpdate);
  }, []);
};
